import React from 'react';
import { Box } from '@hover/blueprint';
import { IJob } from '../../../interfaces/IJob';
import OpenRole from './OpenRole';

interface Props {
  openRoles: IJob[];
}

const OpenRolesList: React.FC<Props> = ({ openRoles }) => (
  <Box w="100%" flexDir="column" alignItems="flex-start">
    {openRoles.map(role => (
      <OpenRole openRole={role} key={role.id} />
    ))}
  </Box>
);

export default OpenRolesList;
